import Vue from 'vue'
import Buefy from 'buefy'
import moment from 'moment'

Vue.use(Buefy, {
  defaultFirstDayOfWeek: 1,
  defaultIconPack: 'ws',
  defaultDateFormatter: (date) => {
    const m = moment(date, 'DD.MM.YYYY')
    if (m.isValid()) {
      return m.format('DD.MM.YYYY')
    }
    return null
  },
  defaultDateParser: (input) => {
    const m = moment(input, 'DD.MM.YYYY')
    if (m.isValid()) {
      return m.toDate()
    }
    return null
  },
  defaultDayNames: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  defaultMonthNames: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
  ],
  defaultModalScroll: 'keep',
  defaultDatepickerMobileNative: false
})
